<template>
    <div class="ed video-tree" style="display: flex;flex-direction: column;justify-content: center
">
        <el-table
                :header-cell-style="{'background':' rgb(227,227,227)'}"
                :row-style="{'background':' rgb(227,227,227)'}"
                :header-row-style="{'background':' rgb(227,227,227)'}"
                height="250"
                :data="getArr"
                border
                style="width: 100%;overflow-y: auto">
            <el-table-column
                    type="index"
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="vc_name"
                    label="批量设置人员"
                    width="130">
            </el-table-column>
            <el-table-column width="150" prop="vc_gsname" label="所属公司"></el-table-column>
            <el-table-column prop="vc_dept" label="所属部门" width="100">
            </el-table-column>
            <el-table-column label="考勤开始时间">
                <template slot-scope="scope">
                    <span v-if="!scope.row.edit">{{scope.row.dt_kqstarttime}}</span>
                    <el-date-picker
                            v-else
                            style="width: 100%"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            size="mini"
                            v-model="scope.row.dt_kqstarttime"
                            type="date"
                            placeholder="选择开始时间"
                    >
                    </el-date-picker>
                </template>
            </el-table-column>
            <el-table-column label="考勤结束时间">
                <template slot-scope="scope">
                    <span v-if="!scope.row.edit">{{scope.row.dt_kqendtime}}</span>
                    <el-date-picker
                            v-else
                            style="width: 100%"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            size="mini"
                            v-model="scope.row.dt_kqendtime"
                            type="date"
                            placeholder="选择结束时间"
                    >
                    </el-date-picker>
                </template>
            </el-table-column>
            <el-table-column
                    prop="i_djId"
                    label="考勤登记号码"
                    width="80">
                <template slot-scope="scope">
                    <span v-if="!scope.row.edit">{{scope.row.i_djid}}</span>
                    <el-input class="inputwidth sc" v-else v-model="scope.row.i_djid" >
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                    <el-button type="text" @click="canEdit(scope.row,scope.row.edit)">{{!scope.row.edit?'编辑':'确定'}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="display:flex;align-items: center;margin:20px 0 20px 154px">
            <span style="margin-right: 20px">考勤方案 </span>
            <el-select @change="change"  size="mini" style="width: 56%;" clearable v-model="select" slot="prepend" placeholder="请选择">
            <el-option v-for="(val,index) in fanganliebiao" :key="index" :label="val.vc_tcname" :value="val.i_id"></el-option>
        </el-select>
        </div>
        <div style="display:flex;align-items: center;margin-left: 182px;margin-bottom: 20px">
            <span style="margin-right: 20px">岗位 </span>
            <el-select @change="gwchange" style="margin-right:6px;width: 20%" size="mini" clearable v-model="select1" slot="prepend" placeholder="请选择">
            <el-option v-for="val in postData" :key="val.id" :label='val.name' :value="val.id"></el-option>
        </el-select>


        </div>
        <div style="display:flex;align-items: center;margin-left: 140px">
            <span style="margin-right: 20px">排班及班次 </span>
            <el-select @change="pbchange" style="margin-right:6px;width: 20%" size="mini" clearable v-model="pbid" slot="prepend" placeholder="请选择">
                <el-option v-for="val in paiban" :key="val.i_ispb" :label='val.vc_ispb' :value="val.i_ispb"></el-option>
            </el-select>
            <span v-if="select!==''&&select1!==''&&pbid!==''&&pbid==0">-</span>
            <el-select v-if="select!==''&&select1!==''&&pbid!==''&&pbid==0" style="margin-right:6px;width: 50%;margin-left: 5px" size="mini" clearable v-model="bcid" slot="prepend" placeholder="请选择">
                <el-option v-for="val in bclist" :key="val.i_bcid" :label='val.vc_bcname' :value="val.i_bcid+1"></el-option>
            </el-select>
        </div>
        <div style="display:flex;align-items: center;margin-top: 20px;margin-left: 153px">
            <span style="margin-right: 20px">是否弹性 </span>
            <div style="margin-left: 0px">
                <el-radio v-model="tanxing" :label="1">是</el-radio>
                <el-radio v-model="tanxing" :label="0">否</el-radio>
            </div>
        </div>
        <div style="display:flex;align-items: center;margin-top: 20px;margin-left: 125px">
            <span style="margin-right: 20px">剩余加班处理 </span>
            <div style="margin-left: 0px">
                <el-radio v-model="i_overtimehandle_type" :label="1">常规转调休</el-radio>
                <el-radio v-model="i_overtimehandle_type" :label="2">多余转加班工资</el-radio>
            </div>
        </div>
        <div slot="footer"  class="dialog-footer" style="text-align: center;margin-top: 25px">
            <el-button style="background-color:rgb(240,219,128);color: black;width: 95px;border: 0 " type="primary" @click="baocun"   size="mini">{{$t('button_save')}}</el-button>
            <el-button style="background-color:rgb(227,227,227);color: black;width: 95px;border: 0 " @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "../api"
    import {baseerp} from "@/utils/baseUrl";
    import {mapActions} from "vuex";

    export default {
        name: "AddAttend",
        props:{
            bianjishuzu:{
                type:Array,
                required:true
            },
            paiban:{
                type:Array,
                required:true
            },
            formvalue:{
                type:Object,
                required:true,
            },
            tableData:{
                type:Array,
                required:true
            }
        },
        data() {
            return {
                tanxing:0,
                i_overtimehandle_type:1,
                f_days:0,
                select:'',
                select1:'',
                select2:'',
                fanganliebiao:[],
                rylist:[],
                bclist:[],
                i_id: 0,
                i_kqtcid: 0,
                postData:[],//岗位列表
                pbid:'',
                bcid:'',
                djmark:'',
                getArr:[],
            }
        },
        watch:{
            formvalue:{
                handler(){
                    if (this.formvalue){
                        this.i_id=this.formvalue.i_id;
                        if (this.i_id!=0){
                            this.edit = true;
                        }else{
                            this.edit = false;
                            // this.newData();
                        }
                    }
                },
                immediate:true,
                deep:true
            },
        },

        mounted() {
            // this.select1=this.bianjishuzu.vc_ispb
            this.kaoqinfangan()
            this.getArr=JSON.parse(JSON.stringify(this.bianjishuzu))
            this.getArr.map(item=>{
                item.edit=false;
                item.dt_kqendtime=item.dt_kqendtime||null
                item.dt_kqstarttime=item.dt_kqstarttime||null

                }

            )
            //console.log(this.getArr)
            // this.getbc()
            this.i_id=0
            this.positionlist()
        },
        computed:{

        },
        // beforeMount(){
        //     // this.select=
        //     console.log(this.form)
        // },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            gwchange(val){
                this.bcid=''
              if(this.select!==''&&this.select1!==''&&this.pbid!==''&&this.pbid==0)  {
                  this.getbc()

              }
            },
            canEdit(val,edit){
                val.edit=!edit
                this.$forceUpdate()
            },
            pbchange(val){
                this.bcid=''

                if(this.select!==''&&this.select1!==''&&this.pbid!==''&&this.pbid==0)  {
                    this.getbc()

                }
                // console.log(val)
            },
            change(val){
              this.i_id=val
                this.select2=''
                if(val==''){
                    this.i_id=0
                }else {
                    let add=this.fanganliebiao.filter(item=>{
                        return item.i_id==val
                    })
                    this.djmark=add[0].vc_djmark
                    this.bcid=''
                }


                if(this.select!==''&&this.select1!==''&&this.pbid!==''&&this.pbid==0)  {
                    this.getbc()

                }
                // this.getbc()
                // console.log(add)
                // console.log(this.i_id)
            },
            baocun(){
                // console.log(this.pbid,this.bcid)
                this.savekq()
                // console.log(this.select2)
                // console.log(1)
            },
            //获取岗位列表

            async positionlist(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };


                let param={
                    i_uid:sessionStorage.getItem("userid")
                }
                let res=await API.positionlist(param)
                if(res.code==1){
                    this.postData=res.data
                    // this.jobhour=val[0]+val[1]
                    // console.log(res.data,11)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            async getbc(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };

                let param={
                    i_mid: this.mid,
                    i_id:this.i_id,
                    positionId:this.select1
                    // i_id
                }
                let res=await API.getbcList(param)
                if(res.code==1){
                    this.bclist=res.data
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            //考勤方案列表
            async kaoqinfangan(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };

                let param={
                    i_mid: this.mid,
                }
                let res=await API.getKqList(param)
                if(res.code==1){
                    this.fanganliebiao=res.data
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            //编辑保存用户人员信息
            async savekq(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };

                let param={
                    i_kqtcid:this.select,
                    i_position:this.select1,
                    i_lruid:sessionStorage.getItem("userid"),
                    list:this.getArr,
                    i_ispb:this.pbid,
                    i_bcid:this.bcid,
                    djmark: this.djmark,
                    i_kqtype:this.tanxing,
                    i_overtimehandle_type:this.i_overtimehandle_type,
                    f_days:this.f_days,
                }
                let res=await API.saveKqRy(param)
                if(res.code==1){
                    // console.log("00000")
                    this.$emit("getList")
                    this.$emit("baocun")
                    // console.log(res)
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    // this.$message.error(res.message);
                    this.$message.error(res.message);
                }else{
                    // this.$message.error(res.message);
                    this.$message.error(res.message);
                };
            },
            cancel(){
                // console.log(this.select)
                // console.log(this.select1)
                // console.log(this.select2)
                this.$emit('close');
            },

        },
    }
</script>

<style lang="scss" scoped>
    .mf{
        margin-left:150px;
    }
    .ed{
        min-width: 600px;
    }
    .flex{
        display: flex;
    }
    .item{
        width: 100%;
    }
    /deep/{
        .num{
            margin-bottom: 12px;
        }
        .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
        .el-tabs--border-card>.el-tabs__content{
            overflow: auto;
        }
        /*.el-table td,.el-table td, .el-table th {
            padding: 8px 0;
        }*/
        .danger-row{
            color: #999;

        }

    }


</style>